let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9oo3s")).then(() => parcelRequire('1QKar'));